import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { AppState } from "../../store/";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faTimes } from "@fortawesome/free-solid-svg-icons";

import { IChatBotLauncher } from "./index";

const Container = styled.div<{ baseSize: number }>`
  width: 22em;
  height: 17em;
  font-size: ${props => props.baseSize}px;
  border: 1px solid #ccc;
  border-radius: 0.8em 0.8em 0 0;
  background: #fff;
`;

const Header = styled.div<{ color: string }>`
  width: 100%;
  height: 3.5em;
  border-radius: 0.8em 0.8em 0 0;
  background: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding-top: 0.24em;
`;

const HeaderText = styled.div`
  width: 70%;
  text-align: center;
  white-space: wrap;
  text-overflow: ellipsis;
`;

const HeaderIcon = styled.div`
  cursor: pointer;
  position: absolute;
  right: 0.5em;
  top: 0.4em;
  border: 1px solid #fff;
  font-size: 1.2em;
  padding: 0.2em 0.5em;
`;

const Main = styled.div`
  display: flex;
  flex-flow: column;
  margin: 0.4em 0;
`;

const MessageContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 8em;
  overflow: hidden;
  margin: 1px;
`;

const MessageImage = styled.img`
  width: 38%;
`;

const Message = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  background: #ccc;
  font-size: 0.8em;
  padding: 0.5em;
  min-height: 4.3em;
  max-height: 90%;
  width: 50%;
  border-radius: 1.6em;

  white-space: normal;
  text-overflow: ellipsis;

  position: relative;
  box-sizing: border-box;
  &:before {
    content: "";
    position: absolute;
    bottom: -0.3em;
    left: -1.1em;
    margin-top: -1.6em;
    border: 0.6em solid transparent;
    border-left: 1.4em solid #ccc;
    z-index: 0;
    -webkit-transform: rotate(146eg);
    transform: rotate(146deg);
  }
`;

const ChevronRightIcon = styled(FontAwesomeIcon)<{ color: string }>`
  margin-left: 20px;
  transition: 0.4s ease;
  pointer-events: none;
`;
const OpenText = styled.div<{ color: string }>`
  font-size: 1.2em;
  color: ${props => props.color};
  pointer-events: none;
`;
const OpenChatBotContainer = styled.div<{ color: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3.8em;
  width: 90%;
  margin: 0 auto;
  border: 2px solid ${props => props.color};
  cursor: pointer;
  transition: 0.4s ease;

  &:hover {
    background: ${props => props.color};
    color: #fff;

    ${ChevronRightIcon} {
      color: #fff;
    }

    ${OpenText} {
      color: #fff;
    }
  }
`;

//const mainMesage =
//  "ご質問はございませんか？簡単にチャットボットがお答えします！";
const StyleA: React.FC<IChatBotLauncher> = ({
  baseFontSize,
  color,
  query,
  showChatBot,
  toggleCloseDialog,
  openText,
  guideTitleA,
  guideMessageA
}) => {
  const launcherImageUrl = useSelector(
    (state: AppState) => state.chatSetting.launcherImage
  );
  const baseSize = baseFontSize;
  return (
    <Container baseSize={baseSize}>
      <Header color={color}>
        <HeaderText>{guideTitleA}</HeaderText>
        <HeaderIcon onClick={toggleCloseDialog}>
          <FontAwesomeIcon icon={faTimes} />
        </HeaderIcon>
      </Header>
      <Main>
        <MessageContainer>
          <MessageImage
            src={launcherImageUrl + `?r=${query}`}
            style={{ marginLeft: `10px` }}
            alt="チャットボットのタイトル画像"
          />
          <Message>{guideMessageA}</Message>
        </MessageContainer>
        <OpenChatBotContainer
          id="chatbot-open-btn"
          color={color}
          onClick={() => showChatBot()}
        >
          <OpenText color={color}>{openText}</OpenText>
          <ChevronRightIcon icon={faChevronRight} color={color} />
        </OpenChatBotContainer>
      </Main>
    </Container>
  );
};

export default StyleA;
